/* eslint-disable */
import createUserProfile from './Actions/CreateUserProfile.action';
import updateUserProfile from './Actions/UpdateUserProfile.action';

const createUserProfileActionCreators = {
  createUserProfile,
  updateUserProfile,
};

export default createUserProfileActionCreators;
